[
   {
      "id": "manage-your-finances-with-app",
      "en": {
         "displayKey": "manage-your-finances-the-right-way-with-an-app",
         "title": "Manage your finances the right way: with an app",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/manage-your-finances-the-right-way-with-an-app"
      },
      "de": {
         "displayKey": "eigene-finanzen-richtig-mit-app-verwalten",
         "title": "Eigene Finanzen richtig mit einer App verwalten",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/eigene-finanzen-richtig-mit-app-verwalten"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "financial-planning-with-monestry-set-goals",
         "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"
      ]
   },
   {
      "id": "wealth-management-with-monestry",
      "en": {
         "displayKey": "wealth-management-with-monestry",
         "title": "Wealth management with Monestry",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/wealth-management-with-monestry"
      },
      "de": {
         "displayKey": "vermögensmanagement-mit-monestry",
         "title": "Vermögensmanagement mit Monestry",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/vermögensmanagement-mit-monestry"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&w=413&q=85&crop=bottom&fit=crop&h=192"
      },
      "relatedPosts": [
         "financial-planning-with-monestry-set-goals",
         "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"
      ]
   },
   {
      "id": "financial-planning-with-monestry-set-goals",
      "en": {
         "displayKey": "financial-planning-with-monestry-set-goals",
         "title": "Financial planning with Monestry: set goals",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/financial-planning-with-monestry-set-goal"
      },
      "de": {
         "displayKey": "finanzielle-planung-mit-monestry-ziele-setzen",
         "title": "Finanzielle Planung mit Monestry: Ziele setzen",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/finanzielle-planung-mit-monestry-ziele-setze"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1515986078061-ef398fc02c9b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1515986078061-ef398fc02c9b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=bottom&w=400&h=200"
      },
      "relatedPosts": [
         "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "manage-your-finances-with-app"
      ]
   },
   {
      "id": "financial-simulations-with-monestry-how-does-my-wealth-grow",
      "en": {
         "displayKey": "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "title": "Financial simulations with Monestry: how does my wealth grow?",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/financial-simulations-with-monestry-how-does-my-wealth-grow"
      },
      "de": {
         "displayKey": "finanzielle-simulationen-mit-monestry-wie-entwickelt-sich-mein-vermögen",
         "title": "Finanzielle Simulationen mit Monestry: wie entwickelt sich mein Vermögen?",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/finanzielle-simulationen-mit-monestry-wie-entwickelt-sich-mein-vermögen"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1528154291023-a6525fabe5b4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1528154291023-a6525fabe5b4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges&w=1&h=0.3"
      },
      "relatedPosts": [
         "financial-planning-with-monestry-set-goals",
         "manage-your-finances-with-app"
      ]
   },
   {
      "id": "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode",
      "en": {
         "displayKey": "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode",
         "title": "Anonymous finance management app: Monestry and its Anonymous Mode",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"
      },
      "de": {
         "displayKey": "finanzen-management-app-anonym-nutzen-monestry-und-ihr-anonymes-modus",
         "title": "Finanzen-Management-App anonym nutzen: Monestry und ihr anonymes Modus.",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/finanzen-management-app-anonym-nutzen-monestry-und-ihr-anonymes-modus"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1645481580015-4b434984c642?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1645481580015-4b434984c642?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1&h=0.33&crop=edges&q=80"
      },
      "relatedPosts": [
         "security-at-monestry",
         "data-privacy-at-monestry",
         "article-id-5"
      ]
   },
   {
      "id": "manage-private-finances-excel-wealth-overview",
      "en": {
         "displayKey": "manage-private-finances-excel-wealth-overview",
         "title": "Manage private finances with Excel (wealth overview)",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/point-of-view/manage-private-finances-excel-wealth-overview"
      },
      "de": {
         "displayKey": "private-finanzen-excel-verwalten-finanzübersicht",
         "title": "Private Finanzen mit Excel verwalten (Finanzübersicht)",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/standpunkte/private-finanzen-excel-verwalten-finanzübersicht"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "point-of-view"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1622463461333-611830d028bd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top",
         "thumb": "https://images.unsplash.com/photo-1622463461333-611830d028bd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=420&h=190&q=80&crop=edges"
      },
      "relatedPosts": [
         "can-psd2-interfaces-be-accessed-by-individuals",
         "manage-your-finances-with-app"
      ]
   },
   {
      "id": "can-psd2-interfaces-be-accessed-by-individuals",
      "en": {
         "displayKey": "can-psd2-interfaces-be-accessed-by-individuals",
         "title": "Can PSD2 interfaces be accessed by individuals?",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/point-of-view/can-psd2-interfaces-be-accessed-by-individuals"
      },
      "de": {
         "displayKey": "als-privatperson-psd2-api-anbinden",
         "title": "Kann eine Privatperson PSD2-Schnittstellen anbinden?",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/standpunkte/als-privatperson-psd2-api-anbinden"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "point-of-view"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1609358905581-e5381612486e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1609358905581-e5381612486e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "manage-private-finances-excel-wealth-overview",
         "manage-your-finances-with-app",
         "data-privacy-at-monestry"
      ]
   },
   {
      "id": "do-you-really-need-banking-app-for-all-your-banks",
      "en": {
         "displayKey": "do-you-really-need-banking-app-for-all-your-bank-accounts",
         "title": "Do you really need a banking app for all your bank accounts?",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/point-of-view/do-you-really-need-banking-app-for-all-your-banks"
      },
      "de": {
         "displayKey": "brauchen-sie-wirklich-banking-app-für-alle-bankkonten",
         "title": "Brauchen Sie wirklich eine Banking-App für alle Ihre Bankkonten?",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/standpunkte/brauchen-sie-wirklich-banking-app-für-alle-banken"
      },
      "author": "Piotr Loboda",
      "category": {
         "key": "point-of-view"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1560472355-536de3962603?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1560472355-536de3962603?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=entropy"
      },
      "relatedPosts": [
         "manage-your-finances-with-app",
         "shares-simply-explained"
      ]
   },
   {
      "id": "multi-broker-apps-overview",
      "en": {
         "displayKey": "multi-broker-apps-overview",
         "title": "Multi-Broker apps: overview",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/point-of-view/multi-broker-apps-overview"
      },
      "de": {
         "displayKey": "multi-depotverwaltung-app-vergleich",
         "title": "Multi-Depotverwaltung: App-vergleich",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/standpunkte/multi-depotverwaltung-app-vergleich"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "point-of-view"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1606189934390-2b10bb7f8094?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.15&crop=top",
         "thumb": "https://images.unsplash.com/photo-1606189934390-2b10bb7f8094?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "manage-your-finances-with-app",
         "financial-planning-with-monestry-set-goals",
         "financial-simulations-with-monestry-how-does-my-wealth-grow"
      ]
   },
   {
      "id": "threshold-wealth-to-consider-private-wealth-management",
      "en": {
         "displayKey": "threshold-wealth-to-consider-private-wealth-management",
         "title": "What threshold wealth should I have to consider private wealth management?",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/point-of-view/threshold-wealth-to-consider-private-wealth-management"
      },
      "de": {
         "displayKey": "ab-welchem-betrag-lohnt-sich-private-vermögensverwaltung",
         "title": "Ab welchem Betrag lohnt sich eine private Vermögensverwaltung?",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/standpunkte/ab-welchem-betrag-lohnt-sich-private-vermögensverwaltung"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "point-of-view"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1611937663641-5cef5189d71b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top",
         "thumb": "https://images.unsplash.com/photo-1611937663641-5cef5189d71b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "manage-your-finances-with-app",
         "etf-simply-explained"
      ]
   },
   {
      "id": "plan-and-track-retirement-financials-with-monestry",
      "en": {
         "displayKey": "plan-and-track-retirement-financials-with-monestry",
         "title": "Plan and track retirement financials with Monestry",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/plan-and-track-retirement-financials-with-monestry"
      },
      "de": {
         "displayKey": "rente-planen-tracken-mit-monestry",
         "title": "Rente planen und tracken mit Monestry",
         "description": "Dies ist ein Platzhaltefr für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/rente-planen-tracken-mit-monestry"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1508672019048-805c876b67e2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=entropy",
         "thumb": "https://images.unsplash.com/photo-1508672019048-805c876b67e2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges"
      },
      "relatedPosts": [
         "financial-planning-with-monestry-set-goals",
         "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "manage-your-finances-with-app"
      ]
   },
   {
      "id": "how-do-we-keep-your-financials-current",
      "en": {
         "displayKey": "how-do-we-keep-your-financials-current",
         "title": "Keeping your financials up to date",
         "description": "Keeping the value of your assets up to date is no easy task. Here is how we do it for you at Monestry.",
         "body": "At Monestry, the secure and efficient handling of your financial data is a cornerstone of our service. Here's a detailed look at our approach. \n\n### Seamless data import and security\n\nWe ensure that your financial data is brought into our app smoothly and securely. With automatic bank sync each time you open Monestry, your transaction data is always current. You can also manually upload transaction files or edit them directly in our user-friendly interface. Once imported, your data is encrypted and securely stored, accessible only to you.\n\n### Automatic updates for Banks and Brokerage Accounts\n\nA few years ago the EU passed a law called in short \"PSD 2\". That law makes it obligatory for all banks to provide a computer-to-computer services which licensed providers can call to receive user transaction data for their respective bank accounts. Naturally, those licensed providers must periodically ask you - the user - to confirm (\"consent\") that it is ok for them to do that on your behalf. \n\nSince that time several specialised companies emerged who made it their core business to help apps like Monestry access user bank data in a secure way. After a thorough analysis we have selected two leading European providers to simplify data-entry for our users. \n\n #### FinAPI\n\nEstablished in 2008 and licensed by BaFin, FinAPI is a Munich-based service provider excelling in payment and account information services. It accesses over 100 million bank accounts, handling more than 13 million requests daily. In 2019, FinAPI joined forces with SCHUFA Holding AG, a central player in Germany's financial system, enhancing its capability to navigate complex financial data.\n\n ▶ [German banks which can provide automated updates](/24-01-SupportedInstitutionsDE.xlsx) \n\n #### GoCardless\n\nA leading payment services company with headquarters in France and the UK, GoCardless is supervised by both ACPR and FCA. It caters to over 85,000 businesses across 30+ countries, processing over $35 billion in transactions annually. Licensed to facilitate transactions from more than 2300 banks in 31 countries, GoCardless expands our reach in providing you with a comprehensive financial overview. \n\n ▶ [Foreign banks which can provide automated updates](/24-01-SupportedInstitutionsForeign.xlsx) \n\n### Automatic updates for Real Estate Accounts\n\nSome of our packages offer automatic value updates for your real property assets in Germany. In this domain, several companies specialize in providing market value estimates for real properties. These are the same companies that banks consult during mortgage evaluations and that realtors use for property sales. Now, you too have access to their expertise. Every six months, we will obtain a new valuation for your property or properties, keeping you informed about their current market worth. \n\n #### Faireal\n\nOur partner Faireal GmbH, a Cologne-based company, has been serving banks and real estate companies in Germany since 2014. Faireal GmbH's property valuations are informed by a comprehensive dataset of over 20 million properties and actual transactions from more than 8000 real estate agents. This extensive database provides our users with highly accurate and reliable property valuations, akin to those used by industry professionals.\n\n### Automatic updates for exchange rates and quotes\n\n #### Exchange Rates\n\nFor our users engaged in global transactions or managing investments across currencies, Monestry provides daily updates on exchange rates. This feature is invaluable for those needing to navigate the complexities of international finance, whether it's for travel, overseas transactions, or managing a diverse investment portfolio.\n\n #### Bonds and Stocks Quotes\n\nInvestment enthusiasts will find Monestry's hourly updates on stock and bond prices particularly useful. While these updates aren't instantaneous, their frequency is sufficient for users to stay abreast of market trends and make informed decisions about their investments.\n\n### How current is our data?\n\n#### Deposits and stock transactions\n\n Updated every time the app starts or you sync data manually.\n\n#### Stock quotes\n\n History: close price of each day. Today: updated hourly (intraday).\n\n#### Exchange rates\n\n Updated daily (official ECB rates).\n\n#### Real estate valuations\n\n Refreshed every 6 month, based on current market data.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/how-do-we-keep-your-financials-current"
      },
      "de": {
         "displayKey": "wie-halten-wir-die-daten-aktuell",
         "title": "Wie halten wir die Daten aktuell?",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "Bei Monestry ist die sichere und effiziente Verwaltung deiner Finanzdaten ein Grundpfeiler unseres Services. Hier ist ein detaillierter Einblick in unseren Ansatz.\n\n### Nahtloser Datenimport und Sicherheit\n\nWir stellen sicher, dass deine Finanzdaten reibungslos und sicher in unsere App übertragen werden. Mit automatischer Bank-Synchronisation jedes Mal, wenn du Monestry öffnest, sind deine Transaktionsdaten immer aktuell. Du kannst auch manuell Transaktionsdateien hochladen oder diese direkt in unserer benutzerfreundlichen Schnittstelle bearbeiten. Sobald importiert, werden deine Daten verschlüsselt und sicher gespeichert, so dass nur du Zugriff darauf hast.\n\n### Automatische Aktualisierungen für Banken und Brokerage-Konten\n\nVor einigen Jahren verabschiedete die EU ein Gesetz, kurz „PSD 2“ genannt. Dieses Gesetz verpflichtet alle Banken, Computer-zu-Computer-Dienste anzubieten, die lizenzierte Anbieter anrufen können, um Benutzertransaktionsdaten für ihre jeweiligen Bankkonten zu erhalten. Natürlich müssen diese lizenzierten Anbieter dich - den Nutzer - regelmäßig um Zustimmung („Einwilligung“) bitten, dass es in Ordnung ist, wenn sie das in deinem Namen tun.\n\nSeitdem haben sich mehrere spezialisierte Unternehmen entwickelt, deren Hauptgeschäft es ist, Apps wie Monestry einen sicheren Zugang zu Benutzerbankdaten zu ermöglichen. Nach einer gründlichen Analyse haben wir zwei führende europäische Anbieter ausgewählt, um die Dateneingabe für unsere Nutzer zu vereinfachen.\n\n#### FinAPI\n\nGegründet im Jahr 2008 und lizenziert von der BaFin, ist FinAPI ein in München ansässiger Dienstleister, der sich auf Zahlungs- und Kontoinformationsdienste spezialisiert hat. Es greift auf über 100 Millionen Bankkonten zu und bearbeitet täglich mehr als 13 Millionen Anfragen. Im Jahr 2019 schloss sich FinAPI mit der SCHUFA Holding AG zusammen, einem zentralen Akteur im deutschen Finanzsystem, um seine Fähigkeit zur Navigation in komplexen Finanzdaten zu verbessern. \n\n ▶ [Automatische Aktualisierungen - Liste der deutsche Banken](/24-01-SupportedInstitutionsDE.xlsx) \n\n#### GoCardless\n\nEin führendes Zahlungsdienstleistungsunternehmen mit Hauptsitz in Frankreich und Großbritannien, GoCardless wird sowohl von der ACPR als auch von der FCA beaufsichtigt. Es bedient über 85.000 Unternehmen in mehr als 30 Ländern und verarbeitet jährlich über 35 Milliarden Dollar an Transaktionen. Es ist lizenziert, Transaktionen von mehr als 2300 Banken in 31 Ländern durchzuführen und erweitert unsere Reichweite, um dir einen umfassenden finanziellen Überblick zu bieten. \n\n ▶ [Automatische Aktualisierungen - Liste der ausländische Banken](/24-01-SupportedInstitutionsForeign.xlsx) \n\n### Automatische Aktualisierungen für Immobilienkonten\n\nEinige unserer Pakete bieten automatische Wertaktualisierungen für deine Immobilienvermögen in Deutschland. In diesem Bereich spezialisieren sich mehrere Unternehmen auf die Bereitstellung von Marktwertschätzungen für Immobilien. Das sind die gleichen Unternehmen, die Banken bei der Bewertung von Hypothekenanträgen konsultieren und die Immobilienmakler für den Verkauf von Immobilien nutzen. Jetzt hast auch du Zugang zu deren Expertise. Alle sechs Monate werden wir eine neue Bewertung für deine Immobilie oder Immobilien einholen und dich über ihren aktuellen Marktwert informieren.\n\n#### Faireal\n\nUnser Partner Faireal GmbH, ein in Köln ansässiges Unternehmen, bedient seit 2014 Banken und Immobilienunternehmen in Deutschland. Die Immobilienbewertungen von Faireal GmbH basieren auf einem umfassenden Datensatz von über 20 Millionen Immobilien und tatsächlichen Transaktionen von mehr als 8000 Immobilienmaklern. Diese umfangreiche Datenbank bietet unseren Nutzern hochgenaue und zuverlässige Immobilienbewertungen, vergleichbar mit denen von Branchenprofis.\n\n### Automatische Aktualisierungen für Wechselkurse und Kurse\n\n #### Wechselkurse\n\nFür unsere Nutzer, die an globalen Transaktionen beteiligt sind oder Investitionen in verschiedenen Währungen verwalten, bietet Monestry stündliche Aktualisierungen der Wechselkurse. Diese Funktion ist unverzichtbar für dich, wenn du die Komplexität des internationalen Finanzwesens meistern musst, sei es für Reisen, Auslandstransaktionen oder die Verwaltung eines vielfältigen Anlageportfolios.\n\n #### Anleihen- und Aktienkurse\n\nInvestitionsbegeisterte werden die stündlichen Aktualisierungen von Monestry zu Aktien- und Anleihepreisen besonders nützlich finden. Obwohl diese Updates nicht instant sind, ist ihre Häufigkeit ausreichend, damit du auf dem Laufenden über Markttrends bleibst und fundierte Entscheidungen über deine Investitionen treffen kannst. \n\n### Wie aktuell sind unsere Daten?\n\n#### Einlagen und Aktientransaktionen\n\n Aktualisierung bei jedem Start der App oder bei manueller Synchronisierung.\n\n#### Aktienkurse\n\n Historie: Schlusskurs jeden Tag. Heute: stündliche Aktualisierung (intraday).\n\n#### Wechselkurse\n\n Tägliche Aktualisierung (offizielle EZB-Kurse).\n\n#### Immobilienbewertungen\n\n Aktualisierung alle 6 Monate, basierend auf aktuellen Marktdaten.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/wie-halten-wir-die-daten-aktuell"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top",
         "thumb": "https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges"
      },
      "relatedPosts": [
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode",
         "security-at-monestry",
         "data-privacy-at-monestry"
      ]
   },
   {
      "id": "account-details",
      "en": {
         "displayKey": "using-account-details-screen",
         "title": "Account Details screen",
         "description": "Keeping the value of your assets up to date is no easy task. Here is how we do it for you at Monestry.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/using-account-detail-screen"
      },
      "de": {
         "displayKey": "account-details-screen-nutzen",
         "title": "Account Details Screen",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/accounts-details-screen-nutzen"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top",
         "thumb": "https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges"
      },
      "relatedPosts": [
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode",
         "security-at-monestry",
         "data-privacy-at-monestry"
      ]
   },
   {
      "id": "reporting",
      "en": {
         "displayKey": "using-reporting-screen",
         "title": "Using Reports",
         "description": "Keeping the value of your assets up to date is no easy task. Here is how we do it for you at Monestry.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/using-reporting-screen"
      },
      "de": {
         "displayKey": "reporting-screen-nutzen",
         "title": "Reports nutzen",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/reporting-screen-nutzen"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top",
         "thumb": "https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges"
      },
      "relatedPosts": [
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode",
         "security-at-monestry",
         "data-privacy-at-monestry"
      ]
   },
   {
      "id": "riester-rente-simply-explained",
      "en": {
         "displayKey": "riester-rente-simply-explained",
         "title": "Riester-Rente - simply explained.",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/market-overview/riester-rente-simply-explained"
      },
      "de": {
         "displayKey": "riester-rente-einfach-erklärt",
         "title": "Riester Rente - einfach erklärt",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/marktübersicht/riester-rente-einfach-erklärt"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "market-overview"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.1&crop=top",
         "thumb": "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "rürup-rente-simply-explained",
         "stock-savings-plan-simply-explained",
         "wealth-management-with-monestry"
      ]
   },
   {
      "id": "rürup-rente-simply-explained",
      "en": {
         "displayKey": "rürup-rente-simply-explained",
         "title": "Rürup-Rente - simply explained.",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/market-overview/rürup-rente-simply-explained"
      },
      "de": {
         "displayKey": "rürup-rente-einfach-erklärt",
         "title": "Rürup-Rente - einfach erklärt",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/marktübersicht/rürup-rente-einfach-erklärt"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "market-overview"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1604156425963-9be03f86a428?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.3&crop=top",
         "thumb": "https://images.unsplash.com/photo-1604156425963-9be03f86a428?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "riester-rente-simply-explained",
         "stock-savings-plan-simply-explained",
         "wealth-management-with-monestry"
      ]
   },
   {
      "id": "etf-simply-explained",
      "en": {
         "displayKey": "etf-rürup-rente-simply-explained",
         "title": "ETFs - simply explained.",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/market-overview/etf-simply-explained"
      },
      "de": {
         "displayKey": "etf-einfach-erklärt",
         "title": "ETFs - einfach erklärt",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/marktübersicht/etf-einfach-erklärt"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "market-overview"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1583752028088-91e3e9880b46?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1583752028088-91e3e9880b46?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "multi-broker-apps-overview",
         "stock-savings-plan-simply-explained",
         "wealth-management-with-monestry"
      ]
   },
   {
      "id": "shares-simply-explained",
      "en": {
         "displayKey": "shares-simply-explained",
         "title": "Shares - simply explained.",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/market-overview/shares-simply-explained"
      },
      "de": {
         "displayKey": "aktien-einfach-erklärt",
         "title": "Aktien - einfach erklärt",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/marktübersicht/aktien-einfach-erklärt"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "market-overview"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1618650551428-199e32d38059?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1618650551428-199e32d38059?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "multi-broker-apps-overview",
         "etf-simply-explained",
         "wealth-management-with-monestry"
      ]
   },
   {
      "id": "stock-savings-plan-simply-explained",
      "en": {
         "displayKey": "stock-savings-plan-simply-explained",
         "title": "Stock savings plans - simply explained.",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/market-overview/stock-savings-plan-simply-explained"
      },
      "de": {
         "displayKey": "sparplan-einfach-erklärt",
         "title": "Sparplan - einfach erklärt",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/marktübersicht/sparplan-einfach-erklär"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "market-overview"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "riester-rente-simply-explained",
         "rürup-rente-simply-explained",
         "wealth-management-with-monestry"
      ]
   },
   {
      "id": "loans-simply-explained",
      "en": {
         "displayKey": "loans-simply-explained",
         "title": "Loans - simply explained.",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/market-overview/loans-simply-explained"
      },
      "de": {
         "displayKey": "kredit-einfach-erklärt",
         "title": "Kredit - einfach erklärt",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/marktübersicht/kredit-einfach-erklärt"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "market-overview"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "financial-planning-with-monestry-set-goals",
         "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "wealth-management-with-monestry"
      ]
   },
   {
      "id": "pension-insurance-simply-explained",
      "en": {
         "displayKey": "pension-insurance-simply-explained",
         "title": "Pension insurance - simply explained.",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/market-overview/pension-insurance-simply-explained"
      },
      "de": {
         "displayKey": "rentenversicherung-einfach-erklärt",
         "title": "Rentenversicherung - einfach erklärt",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/marktübersicht/rentenversicherung-einfach-erklärt"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "market-overview"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.17&crop=top",
         "thumb": "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "plan-and-track-retirement-financials-with-monestry",
         "stock-savings-plan-simply-explained",
         "wealth-management-with-monestry"
      ]
   },
   {
      "id": "monestry-and-other-finance-management-applications-subjective-feature-comparison",
      "en": {
         "displayKey": "monestry-and-other-finance-management-applications-subjective-feature-comparison",
         "title": "Monestry and other finance management applications - a subjective feature comparison.",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/new-features/monestry-and-other-finance-management-applications-subjective-feature-comparison"
      },
      "de": {
         "displayKey": "monestry-andere-finanzmanagement-anwendungen-feature-vergleich-alternativen",
         "title": "Monestry und andere Finanzmanagement-Anwendungen - ein subjektiver Feature-Vergleich.",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Welche Alternativen gibt es? \n\n Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/neue-features/monestry-andere-finanzmanagement-anwendungen-feature-vergleich-alternativen"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "new-features"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1513611771808-7e8ab7f1dec6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1513611771808-7e8ab7f1dec6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "wealth-management-with-monestry",
         "do-you-really-need-banking-app-for-all-your-banks",
         "multi-broker-apps-overview"
      ]
   },
   {
      "id": "security-at-monestry",
      "en": {
         "displayKey": "security-at-monestry",
         "title": "Security at Monestry",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/new-features/security-at-monestry"
      },
      "de": {
         "displayKey": "sicherheit-bei-monestry",
         "title": "Sicherheit bei Monestry",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Welche Alternativen gibt es? \n\n Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/neue-features/sicherheit-bei-monestry"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "new-features"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1582139329536-e7284fece509?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1582139329536-e7284fece509?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "data-privacy-at-monestry",
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"
      ]
   },
   {
      "id": "data-privacy-at-monestry",
      "en": {
         "displayKey": "data-privacy-at-monestry",
         "title": "Data Privacy at Monestry",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet. \n\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\n\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \n\n Where updates are not available online, we make it simple to provide them manually: rürup / riester / insurance / betriebliche rente.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/new-features/data-privacy-at-monestry"
      },
      "de": {
         "displayKey": "datenschutz-bei-monestry",
         "title": "Datenschutz bei Monestry",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Welche Alternativen gibt es? \n\n Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/neue-features/datenschutz-bei-monestry"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "new-features"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1634224152857-69c415153d4a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1634224152857-69c415153d4a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "security-at-monestry",
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"
      ]
   },
   {
      "id": "manage-your-private-finances-with-app",
      "hiddenFromBrowsing": true,
      "en": {
         "displayKey": "manage-your-private-finances-with-app",
         "title": "Manage your private finances with an app",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/manage-your-private-finances-with-app"
      },
      "de": {
         "displayKey": "private-finanzen-richtig-mit-app-verwalten",
         "title": "Private Finanzen richtig mit einer App verwalten",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/private-finanzen-richtig-mit-app-verwalten"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "financial-planning-with-monestry-set-goals",
         "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"
      ]
   },
   {
      "id": "manage-your-finances-better-with-app",
      "hiddenFromBrowsing": true,
      "en": {
         "displayKey": "manage-your-finances-better-with-app",
         "title": "Manage your finances better: with an app",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/manage-your-finances-better-with-app"
      },
      "de": {
         "displayKey": "eigene-finanzen-besser-mit-app-verwalten",
         "title": "Eigene Finanzen besser mit einer App verwalten",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/anleitung/eigene-finanzen-besser-mit-app-verwalten"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "financial-planning-with-monestry-set-goals",
         "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"
      ]
   },
   {
      "id": "manage-your-private-finances-better-with-app",
      "hiddenFromBrowsing": true,
      "en": {
         "displayKey": "manage-your-private-finances-better-with-app",
         "title": "Manage your private finances better: with an app",
         "description": "This is a placeholder for a future article.",
         "body": "### Please come back at a later date. \n\n  This article is not available yet.",
         "published": "March 04, 2022",
         "datetime": "2022-03-04",
         "readingTime": "6 Min",
         "href": "/en/blog/guide/manage-your-private-finances-better-with-app"
      },
      "de": {
         "displayKey": "private-finanzen-besser-mit-app-verwalten",
         "title": "Private Finanzen besser mit einer App verwalten",
         "description": "Dies ist ein Platzhalter für einen zukünftigen Artikel.",
         "body": "### Dieser Artikel ist noch nicht verfügbar. \n\n  Bitte besuche uns zu einem späteren Zeitpunkt noch einmal.",
         "published": "4. März 2022",
         "datetime": "2020-03-04",
         "readingTime": "6 Min",
         "href": "/de/blog/guide/private-finanzen-besser-mit-app-verwalten"
      },
      "author": "Piotr Loboda",
      "href": "#",
      "category": {
         "key": "guide"
      },
      "image": {
         "article": "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges",
         "thumb": "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
      },
      "relatedPosts": [
         "financial-planning-with-monestry-set-goals",
         "financial-simulations-with-monestry-how-does-my-wealth-grow",
         "use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"
      ]
   }
]